import React from 'react';
import { useTranslation } from 'react-i18next';

import './footer.css';

function Footer(): JSX.Element {
  const { t } = useTranslation();

  return (
    <footer className='site-footer'>
      <div className='footer-top'>
        <div className='footer-desc-col'>
          <p>{t('footer.tax-exempt-status')}</p>
          <p>{t('footer.mission-statement')}</p>
          <p>{t('footer.donation-initiatives')}</p>
        </div>
      </div>
      <div className='footer-bottom'>
        <p>Jingga Code © {new Date().getFullYear()} — SMKN 1 Rongga</p>
      </div>
    </footer>
  );
}

Footer.displayName = 'Footer';
export default Footer;
